/**
 * Vehicle input — one frame's worth, expressed as continuous + boolean bits.
 *
 * - throttle/steer are -1..1.
 * - boolean buttons are packed to InputBits when serialized (see @polyloop/protocol).
 */
export interface VehicleInput {
  /** Forward (+1) ↔ Reverse (-1). */
  throttle: number;
  /** Right (+1) ↔ Left (-1). */
  steer: number;
  drift: boolean;
  boost: boolean;
  brake: boolean;
  reset: boolean;
  lookBack: boolean;
}

export const EMPTY_INPUT: Readonly<VehicleInput> = Object.freeze({
  throttle: 0,
  steer: 0,
  drift: false,
  boost: false,
  brake: false,
  reset: false,
  lookBack: false,
});

export const enum InputBits {
  Drift = 1 << 0,
  Boost = 1 << 1,
  Brake = 1 << 2,
  Reset = 1 << 3,
  LookBack = 1 << 4,
}

export const copyInput = (out: VehicleInput, src: Readonly<VehicleInput>): VehicleInput => {
  out.throttle = src.throttle;
  out.steer = src.steer;
  out.drift = src.drift;
  out.boost = src.boost;
  out.brake = src.brake;
  out.reset = src.reset;
  out.lookBack = src.lookBack;
  return out;
};

export const makeInput = (): VehicleInput => ({
  throttle: 0,
  steer: 0,
  drift: false,
  boost: false,
  brake: false,
  reset: false,
  lookBack: false,
});
